import React, {Component} from 'react';
import './AccountPlans.css';

class AccountPlans extends Component {
	render() {
		const {
			className,
			subscriptionLevel,
			persistSubscriptionLevel,
			futureTense = false
		} = this.props;

		return (
			<div className={`AccountPlans ${className || ''}`}>
				<AccountPlan
					name="Access"
					cost={25}
					active={subscriptionLevel === 'access'}
					benefits={[
						'Gain exposure as a quality provider in the local marketplace.',
						'Drive interest and engagement, and connect with customers near you.',
						'Let customer reviews demonstrate you’re a serious choice for quality services in your industry.',
						'Support via our online database.'
					]}
					subscriptionLevel={'access'}
					persistSubscriptionLevel={persistSubscriptionLevel}
					futureTense={futureTense}
				/>
				<AccountPlan
					className="essentials"
					name="Essentials"
					value="Best value"
					benefitsPlus="Access"
					active={subscriptionLevel === 'essentials'}
					cost={55}
					benefits={[
						'Stand out from the pack with advanced profile customisation.',
						'Access detailed analytics to attract more interest and follow up with potential customers.',
						'Convert more leads and build more brand ambassadors for your service.',
						'Standard Email Support'
					]}
					subscriptionLevel={'essentials'}
					persistSubscriptionLevel={persistSubscriptionLevel}
					futureTense={futureTense}
				/>
				<AccountPlan
					name="Premium"
					cost={75}
					monthly={false}
					benefitsPlus="Essentials"
					active={subscriptionLevel === 'premium'}
					benefits={[
						'Let one of our experts help you to setup your profile page.',
						'Enhanced engagement with interested customers.',
						'Showcase what you do.',
						'Priority Email Support'
					]}
					subscriptionLevel={'premium'}
					persistSubscriptionLevel={persistSubscriptionLevel}
					futureTense={futureTense}
				/>
			</div>
		);
	}
}

class AccountPlan extends Component {
	constructor() {
		super();

		this.onSignUp = () => {
			this.props.persistSubscriptionLevel(this.props.subscriptionLevel);
		};
	}

	render() {
		const {
			className,
			name = 'Essentials',
			value,
			cost = 55,
			monthly = true,
			annualCost,
			benefits = [],
			benefitsPlus,
			active = false,
			futureTense
		} = this.props;

		return (
			<div className={`AccountPlan ${className || ''} ${active ? 'active' : ''}`}>
				<div className="AccountPlan-header">
					<div className="AccountPlan-brand">
						B2<span>Me</span>
					</div>
					<h2>{name}</h2>
				</div>
				<div className="AccountPlan-cost">
					{value && <div className="AccountPlan-value">{value}</div>}
					<div className="AccountPlan-main">
						<span className="AccountPlan-currency">$</span>
						<span className="AccountPlan-amount">{cost}</span>
					</div>
					<div className="AccountPlan-period">
						{monthly ? 'per month' : 'per month (minimum 12 months)'}
					</div>
					{annualCost && <div className="AccountPlan-longer">${annualCost} annually</div>}
				</div>
				{active ? (
					<div className="AccountPlan-active">
						<span className="icon icon-check" />
						<label>{futureTense ? 'You have chosen this plan' : 'You are on this plan'}</label>
					</div>
				) : (
					<button className="AccountPlan-signup" onClick={this.onSignUp}>
						{futureTense ? 'Select' : 'Sign up'}
					</button>
				)}

				<ul className="AccountPlan-benefits">
					{benefitsPlus && (
						<li className="AccountPlan-butwaittheresmore">
							All the benefits of <em>{benefitsPlus}</em>, plus:
						</li>
					)}
					{benefits &&
						benefits.map((benefit, idx) => (
							<li key={idx + '_' + benefit}>
								<span className="icon icon-check" />
								<div className="AccountPlan-item">{benefit}</div>
							</li>
						))}
				</ul>
			</div>
		);
	}
}

export default AccountPlans;



// WEBPACK FOOTER //
// ./src/profile/AccountPlans.js